import { useMutation } from 'react-query';
import { UploadXerPayload } from 'api/mutations/uploadXerFile.mutation';
import { network } from 'services/network';

const mutationFn = (params) => {
    const data = new FormData();
    data.append('file', params.file, params.file.name);
    return network
        .post('api/bo/plfAnalysis', data, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then((response) => {
            return response.data;
        });
};
export const useMutationUploadPlfFile = () => {
    return useMutation<any, QueryError, Partial<UploadXerPayload>>({ mutationFn: (params) => mutationFn(params) });
};
